import { useState } from 'react'
import { Press } from '@dorixona/ui'
import { Icon } from '../../ui/Icon'
import { Modal } from '../../ui/Modal'

export interface IssuedPasswordProps {
  name: string
  password: string
  onClose: () => void
  onToast: (message: string) => void
}

/**
 * Временный пароль — один раз: новому сотруднику или после сброса. Это не
 * форма, а сообщение, которое нельзя пропустить, поэтому окно.
 */
export function IssuedPassword({ name, password, onClose, onToast }: IssuedPasswordProps) {
  // Пароль скопирован: значок меняется на галочку.
  const [copied, setCopied] = useState(false)

  /**
   * Пароль в буфер обмена: его вставят в мессенджер, а не переписывают с
   * экрана. Буфер бывает закрыт (не HTTPS, запрет браузера) — тогда пароль
   * остаётся на экране и выделяется целиком одним щелчком.
   */
  function copy() {
    navigator.clipboard.writeText(password).then(
      () => {
        setCopied(true)
      },
      () => {
        onToast('Не удалось скопировать — выделите пароль и скопируйте вручную')
      },
    )
  }

  return (
    <Modal title="Временный пароль" onClose={onClose}>
      <p>
        Передайте пароль сотруднику {name}. Он виден <b>один раз</b> — закроете окно, и его больше
        не покажут; при первом входе сотрудник сменит его сам.
      </p>
      <div className="stf-password">
        <code className="ui-code">{password}</code>
        <Press
          as="button"
          type="button"
          className="ui-iconbtn"
          squish="icon"
          aria-label={copied ? 'Пароль скопирован' : 'Копировать пароль'}
          data-tip={copied ? 'Скопировано' : 'Копировать'}
          onPress={copy}
        >
          <Icon name={copied ? 'i-check' : 'i-copy'} />
        </Press>
        <Press as="button" type="button" className="ui-btn" squish="card" onPress={onClose}>
          Записал, закрыть
        </Press>
      </div>
    </Modal>
  )
}
